// function for the logic to set modal heights
import { lockBody, unlockBody } from "./helpers/body-lock-toggle";

let windowWidth = 0;

function setModalHeights(checkWindowWidth) {
    if (checkWindowWidth) {
        if (window.innerWidth !== windowWidth) {
            windowWidth = window.innerWidth;
            setHeight();
        }
    } else {
        setHeight();
    }

    function setHeight() {
        const iosVhFixElements = document.querySelectorAll('.ios-vh-fix');
        const viewportHeight = window.innerHeight;

        for (let iosVhFixElement of iosVhFixElements) {
            iosVhFixElement.style.height = viewportHeight + 'px';
            iosVhFixElement.style.minHeight = viewportHeight + 'px';
            iosVhFixElement.style.maxHeight = viewportHeight + 'px';
        }
    }
}

function adjustModalHeight() {
    const isiOS = /iPad|iPhone|iPod/.test(navigator.platform);

    if (isiOS) {
        const setModalHeightThrottled = _throttle(() => {
            // Check if the mobile nav is closed before attempting to resize (fix to ios bug interacting with search in mobile menu)
            setModalHeights(true); // Call the function to set modal heights on resize/scroll
        }, 100);

        // Call the function to set modal heights on page load
        setModalHeights(false);

        // Attach the throttled function to the resize and scroll events
        window.addEventListener('touchstart', setModalHeightThrottled);
        window.addEventListener('scroll', setModalHeightThrottled);
    }

    const downloadContactButton = document.querySelector('[data-download-contact-button]');
    const contactInfoModal = document.querySelector('[data-contact-info-holder]');

    if (downloadContactButton && isiOS) {
        if (contactInfoModal) {
            const copyInputs = contactInfoModal.querySelectorAll('input');

            contactInfoModal.addEventListener('click', (event) => {
                const clickedEventItem = event.target;

                if (clickedEventItem.hasAttribute('data-lightbox-close')) {
                    closeLightBox();
                }

                function closeLightBox() {
                    contactInfoModal.dataset.active = 'false';
                    unlockBody();
                    setTimeout(() => {
                        contactInfoModal.dataset.hidden = 'true';
                    }, 300);
                }
            });

            downloadContactButton.addEventListener('click', () => {
                event.preventDefault();
                openLightBox();
            });

            function openLightBox() {
                contactInfoModal.dataset.hidden = 'false';
                lockBody();
                setTimeout(() => {
                    contactInfoModal.dataset.active = 'true';
                }, 50);
            }

            // Loop through the copyInputs and add event listeners
            copyInputs.forEach((input) => {
                let defaultText = input.value;

                input.addEventListener('click', async (event) => {
                    try {
                        await navigator.clipboard.writeText(defaultText);
                        input.value = 'Copied to clipboard!';
                    } catch (err) {
                        console.error('Unable to copy text to clipboard', err);
                    }

                    setTimeout(() => {
                        input.value = defaultText;
                    }, 2000);
                });
            });
        }
    }
}

// Run the main function when the DOM is loaded
window.addEventListener('load', adjustModalHeight);